import React from "react";
import { Switch } from "react-router";
import RouteWithSubRoutes from "./RouteWithSubRoutes";
import { IRoute } from "./router.config";
import AuthService from "../services/AuthService";
import Navbar from "../components/Navbar/Navbar";
import { getCheckTenant } from "../services/utils/getCheckTenant";

interface IProps {
  routes: IRoute[];
}

const Router: React.FC<IProps> = ({ routes }) => {
  const authenticated = !!AuthService.getCurrentUser();
  const checkTenant = getCheckTenant();

  return (
    <>
      {authenticated && checkTenant && <Navbar />}
      <div className="container">
        <Switch>
          {routes.map((route: IRoute) => (
            <RouteWithSubRoutes key={route.path} {...route} />
          ))}
        </Switch>
      </div>
    </>
  );
};

export default Router;
